import { render, staticRenderFns } from "./_DepartmentDocumentation.vue?vue&type=template&id=2c50797a&"
import script from "./_DepartmentDocumentation.vue?vue&type=script&lang=ts&"
export * from "./_DepartmentDocumentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports